import { motion } from "framer-motion";
import { PROCESS } from "@/data/site";

export const Process = () => {
  return (
    <section data-testid="process-section" className="py-16 sm:py-20 lg:py-28 bg-background">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-2xl">
          <span className="text-sm uppercase tracking-[0.2em] font-bold text-red-700">Simple & Transparent</span>
          <h2 className="mt-3 font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-slate-950">
            How It Works
          </h2>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {PROCESS.map((p, i) => (
            <motion.div
              key={p.step}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              data-testid={`process-step-${i}`}
              className="relative rounded-2xl bg-white border border-slate-200 p-7 hover:-translate-y-1 hover:shadow-lg transition-all duration-300"
            >
              <span className="font-display font-extrabold text-5xl text-red-700/15">{p.step}</span>
              <h3 className="mt-2 font-display font-bold text-xl text-slate-900">{p.title}</h3>
              <p className="mt-2 text-slate-600 leading-relaxed">{p.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
